import { mdiBellRingOutline } from '@mdi/js'

export default {
  title: 'Announcement',
  to: 'announcement-hod-list',
  icon: mdiBellRingOutline,
  resource: 'AnnouncementHeadDepartment',
  action: 'read',
}
